<template>
    <div class="assets">
        <header>
            <div class="header">
                <h2>数字资产</h2>
                <img src="@/assets/imgs/btn2.png" alt="">
            </div>

        </header>
        <section>
            <h5><span>上传资产（{{ data1.total }}）</span><span @click="router.push('/workbench/assets-lib/asset')">查看更多 <van-icon name="arrow-double-right" /></span></h5>
            <ul class="assets_list">
                <li v-for="item in data1.list" :key="item.id">
                    <AssetsCard :item="item" />
                </li>
            </ul>
        </section>
                <section>
            <h5><span>已购买资产（{{ data2.total }}）</span><span @click="router.push('/workbench/assets-lib/asset')">查看更多 <van-icon name="arrow-double-right" /></span></h5>
            <ul class="assets_list">
                <li v-for="item in data2.list" :key="item.id">
                    <AssetsCard :item="item" />
                </li>
            </ul>
        </section>
        <section>
            <h5><span>已发布资产（{{ data3.total }}）</span><span @click="router.push('/workbench/assets-lib/asset')">查看更多 <van-icon name="arrow-double-right" /></span></h5>
            <ul class="assets_list">
                <li v-for="item in data3.list" :key="item.id">
                    <AssetsCard :item="item" />
                </li>
            </ul>
        </section>

    </div>

</template>

<script setup>
import { http } from '@/request/http'
import { onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { timeStampFormat } from '@/utils/util'
import AssetsCard from '../../components/assetsCard.vue'

const router = useRouter()

const data1 = reactive({
    list: [],
    total: 0
})

const data2 = reactive({
    list: [],
    total: 0
})

const data3 = reactive({
    list: [],
    total: 0
})

const fetchList = () => {
    http.get('/app-api/model/user-asset/page?pageNo=1&pageSize=2&assetSource=1&sort=0&sortType=1').then(res => {
        data1.list = res.list
        data1.total = res.total
    })
    http.get('/app-api/model/user-asset/page?pageNo=1&pageSize=2&assetSource=2&sort=0&sortType=1').then(res => {
        data2.list = res.list
        data2.total = res.total
    })
    http.get('/app-api/model/asset-release/page?pageNo=1&pageSize=2').then(res => {
        data3.list = res.list
        data3.total = res.total
    })
}

onMounted(() => {
    fetchList()
})

</script>

<style lang="scss" scoped>
@use '../common.scss';

.assets {
    background-color: #F6F6F6;
    min-height: 100vh;

    header {
        padding: 15rem;
        background-color: #fff;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                height: 29rem;
            }
        }
    }

    section {
        margin: 10rem;
        min-height: 230rem;
        background-color: #fff;

        h5 {
            padding: 15rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16rem;
            font-weight: normal;
            span:nth-child(2) {
                font-size: 12rem; color: #8A8A8A;
            }
        }

        ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            padding: 0 10rem;
            li {
                width: 186rem;
            }
        }
    }
}
</style>